/** Shared site identity for legal pages, footers, and marketing copy. */
export const SITE_NAME = "Smart Setup Solutions";

export const SITE_DOMAIN =
  process.env.REACT_APP_FIREBASE_SITE_DOC || "smartsetupsolutions.com";

export const SITE_EMAIL = "hello@smartsetupsolutions.com";

export const SITE_URL = `https://${SITE_DOMAIN}`;

export const SITE_LOGO_URL = `${process.env.PUBLIC_URL || ""}/logo.png`;

export function resolveSiteName(webinfo = {}) {
  return String(webinfo?.name || SITE_NAME).trim() || SITE_NAME;
}

export function resolveSiteEmail(webinfo = {}) {
  return String(webinfo?.email || SITE_EMAIL).trim() || SITE_EMAIL;
}

export function resolveSitePhone(webinfo = {}) {
  return String(webinfo?.phone || webinfo?.phonecall || "").trim();
}
